/* eslint-disable no-case-declarations,camelcase */

import {REPORT_UPDATES_JOBS_STATUSES} from '../../const'; // TODO REPLACE ?

const ACTIONS_TYPES = {
  REFRESH_REPORT: 'REFRESH_REPORT',
  REFRESH_REPORT_SUCCESS: 'REFRESH_REPORT_SUCCESS',

  // Report updates relative jobs
  JOB_REGISTERED: 'JOB_REGISTERED',
  JOB_POLLED: 'JOB_POLLED',
  JOB_HANDLED: 'JOB_HANDLED'
};

const ActionCreators = dispatch => ({
  refreshReport: conn => {
    dispatch({type: ACTIONS_TYPES.REFRESH_REPORT, payload: conn});
  },
  refreshReportSuccess: conn => {
    dispatch({type: ACTIONS_TYPES.REFRESH_REPORT_SUCCESS, payload: conn});
  },
  jobRegistered: job => {
    dispatch({
      type: ACTIONS_TYPES.JOB_REGISTERED,
      payload: job
    });
  },
  jobPolled: pollData => {
    dispatch({
      type: ACTIONS_TYPES.JOB_POLLED,
      payload: pollData
    });
  },
  jobHandled: jobId => {
    dispatch({
      type: ACTIONS_TYPES.JOB_HANDLED,
      payload: jobId
    });
  }
});

const initialState = {
  updateJobs: {},
  refreshing: []
};

// eslint-disable-next-line default-param-last,complexity
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS_TYPES.REFRESH_REPORT:
      return {
        ...state,
        refreshing: [...state.refreshing, action.payload.siren + action.payload.schema_name]
      };

    case ACTIONS_TYPES.REFRESH_REPORT_SUCCESS:
      return {
        ...state,
        refreshing: state.refreshing.filter(id => id !== action.payload.siren + action.payload.schema_name)
      };

    case ACTIONS_TYPES.JOB_REGISTERED: {
      const {request_id, report_id} = action.payload;

      return {
        ...state,
        updateJobs: {
          ...Object.values(state.updateJobs).filter(j => j.report_id !== report_id),
          [request_id]: {
            ...action.payload,
            status: REPORT_UPDATES_JOBS_STATUSES.REGISTERED,
            handled: false
          }
        }
      };
    }

    case ACTIONS_TYPES.JOB_POLLED: {
      const {request_id, status} = action.payload;

      const job = state.updateJobs[request_id];
      if (!job) return state;

      return {
        ...state,
        updateJobs: {
          ...state.updateJobs,
          [request_id]: {
            ...job,
            status,
            lastPollData: action.payload
          }
        }
      };
    }

    case ACTIONS_TYPES.JOB_HANDLED: {
      const requestId = action.payload;

      return {
        ...state,
        updateJobs: {
          ...state.updateJobs,
          [requestId]: {
            ...state.updateJobs[requestId],
            startTime: null,
            handled: true
          }
        }
      };
    }
    default:
      throw new Error(`Action type ${action.type} doesn't exist`);
  }
};

export {reducer, initialState, ActionCreators};
